/* global globalThis */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from 'prop-types';
import {
  useTranslations,
  useStyles
} from "sdk/custom-hooks";
import rectangleQuizImage from "../../../assets/images/rectangleQuiz.png";
import { useHistory } from "react-router-dom";
import { getCourseSectionApiData, practiceQuizAttemptsData } from "sdk/actions/getSelfLearningAction";
import { useDispatch, useSelector } from "react-redux";
import OverlayButton from "../../../constants/OverlayButton";
import { useTheme } from "../../../constants/themeProvider";
import moment from "moment";
import CommonButton from "../../../constants/CommonButton";
import { getQuizDataForQuizIdAction } from "sdk/actions/getQuiz";
import {
  Radio,
  FormControlLabel,
  Button,
  Typography,
  Grid,
  Checkbox,
  Box,
  Tooltip,
  IconButton,
  Modal
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import ReplayIcon from "@material-ui/icons/Replay";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { ColorsConstant } from "../../../constants/colorConstant";

const computeQuizScore = (questions, selectedAnswers) => {
  let correct = 0;
  let incorrect = 0;

  questions.forEach((question, index) => {
    const selectedAnswer = selectedAnswers[index] || [];
    const questionOptions = Array.isArray(question?.options)
      ? question.options
      : [];
    const correctOptions = questionOptions
      .filter((option) => option?.correct)
      .map((option) => option?._id);

    if (Array.isArray(selectedAnswer)) {
      const isAllCorrect =
        selectedAnswer.length === correctOptions.length &&
        selectedAnswer.every((val) => correctOptions.includes(val));

      if (isAllCorrect) {
        correct += 1;
      } else {
        incorrect += 1;
      }
      return;
    }

    if (correctOptions.includes(selectedAnswer)) {
      correct += 1;
    } else {
      incorrect += 1;
    }
  });

  return { correct, incorrect };
};

/**
 * Instructions block.
 * @param props
 * @returns {*}
 * @constructor
 */
function InstructionBlock(props) {
  let dispatch = useDispatch();
  const [mySectionData, setMySectionData] = useState([]);
  const history = useHistory();
  const theme = useTheme();
  const classes = useStyles(styles)();
  const t = useTranslations();
  const [testDisabled, setTestDisabled] = useState(false);
  const [quizAttemptsCount, setQuizAttemptsCount] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [courseStartDate, setCourseStartDate] = useState("");
  const [open, setOpen] = useState(false);
  const [imgSrc, setImgSrc] = useState("");
  const [zoom, setZoom] = useState(1);
  const contentRef = useRef(null);
  let learningData = useSelector((state) => state.selfLearningReducers);
  const { dataId, sectionId } = learningData;
  const sectionIdFromRedux = useSelector(state => state.selfLearningReducers.sectionId) || sectionId;  
  const {
    startQuiz,
    quiz,
    quizAttemptForResult,
    unlockEvaluationTest,
    certificateUnlocked,
    startButtonClicked,
    selectedQuizCard,
    courseName,
    handleUpdateCourseProgress,
    course_id,
    contentId,
    setSubmittedTest,
    setIsPracticeQuizModal,
    setPracticeQuizData,
    setShowCourseModalAfterQuiz,
    coursePercentage,
    setSuppressCourseModal,
    isCourseExpired,
    neverExpired
  } = props;
  
  const settingsData = useSelector((state) => state.settingsReducers.settingsData?.data);
  const fetchData = async () => {
    dispatch(getCourseSectionApiData(course_id)).then((response) => {
      try {
        const courseStartingDate = moment(
          response?.data?.courseId?.startDate
        ).format("DD-MM-YYYY, HH:mm:ss");
        setCourseStartDate(courseStartingDate);
        setMySectionData(response?.data?.evaluationTest?.[0] || {});
      } catch (error) {
        console.log("Error -", error.message);
      }
    });
  };

  useEffect(() => {
    const quizAttemptsCount = settingsData?.data?.[0]
      ? settingsData?.data?.[0]?.customization?.quizAttempts
      : 3;
    setQuizAttemptsCount(quizAttemptsCount);
  }, [settingsData]);

  const isTestDisabled =
    unlockEvaluationTest === false ||
    mySectionData?.quizAttempts >= quizAttemptsCount ||
    certificateUnlocked === true;

  useEffect(() => {
    if (course_id !== undefined) {
      fetchData();
    }
  }, []);

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const quizModal = ({ showModal, closeModal }) => {
    return (
      <Box
        className={classes.modalBg + ` ${showModal ? "show" : ""}`}
        onClick={closeModal}
      >
        <Box
          className={classes.modalContent}
          onClick={(e) => e.stopPropagation()}
        >
          <Box className={classes.heading}>
            <h2 className={classes.headingText}>
              {t("Your quiz is expired!")}
            </h2>
            <Box className={classes.okAlign}>
              <CommonButton
                onClick={() => history.push("/courses")}
                classStyleHeading={classes.okBtn}
                title={t("Ok")}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  };

  useEffect(() => {
    if (startButtonClicked) {
      const evaluationQuiz = selectedQuizCard?.data?.evaluationTest?.[0]?.testId;
      if (evaluationQuiz?.mode && evaluationQuiz?.slug) {
        history.push("/quiz/" + evaluationQuiz.mode + "/" + evaluationQuiz.slug + "/" + course_id, {courseId: course_id, quizMode: evaluationQuiz.mode});
      }
    }
  }, [startButtonClicked]);
  useEffect(() => {
    if (quiz?._id) {
      dispatch(getQuizDataForQuizIdAction(quiz._id))
        .then((response) => {
          if (isTestDisabled) {
            setTestDisabled(true);
          } else {
            setTestDisabled(false);
          }
        })

        .catch((error) => {
          console.error("Error fetching quiz data:", error);
        });
    }
  }, [quiz?._id, courseStartDate]);


  const showResult = ()=>{
    history.push(`/reports/${quiz?.slug}/${course_id}`, {courseId:course_id, slug:quiz?.slug, pageType: "Instruction", courseName: courseName, redirectFromViewResult: true  })
  }

  // for practice quiz

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [correctCount, setCorrectCount] = useState(0);
  const [incorrectCount, setIncorrectCount] = useState(0);
  const isMockTest = props?.quiz?.mode === "mock-test";

  // Reset state when practice quiz changes (for multiple practice quizzes)
  useEffect(() => {
    setCurrentQuestionIndex(0);
    setSelectedAnswers({});
    setCorrectCount(0);
    setIncorrectCount(0);
    setSubmitted(false);
    if (typeof setSubmittedTest === 'function') setSubmittedTest(false);
  }, [quiz?._id]);

  let questions = [];
  let currentQuestion = null;
  let mappedOptions = [];

  // Assign values based on mode
  if (!isMockTest) {
    questions = props?.quiz?.questions || [];
    currentQuestion = questions[currentQuestionIndex];
    const questionOptions = Array.isArray(currentQuestion?.options)
      ? currentQuestion.options
      : [];
    if (currentQuestion) {
      mappedOptions = questionOptions.map((option) => ({
        value: option?._id,
        label: (option?.text || "").replace(/<[^>]+>/g, ""),
        isCorrect: option?.correct === true,
      }));
    }
  }

  useEffect(() => {
    if (contentRef.current) {
      const images = contentRef.current.querySelectorAll("img");
      images.forEach((img) => {
        img.style.cursor = "pointer";
        img.onclick = () => {
          setImgSrc(img.src);
          setZoom(1); // reset zoom each time
          setOpen(true);
        };
      });
    }
  }, [currentQuestion?.title]);

  const handleZoomIn = () => setZoom((z) => Math.min(z + 0.2, 3));
  const handleZoomOut = () => setZoom((z) => Math.max(z - 0.2, 0.5));

  // Handle option selection
  const handleOptionChange = (event) => {
    setSelectedAnswers({
      ...selectedAnswers,
      [currentQuestionIndex]: event.target.value,
    });
  };

  // Handle option selection for multiple-choice questions
  const handleOptionChangeForMultiple = (event, optionValue) => {
    const isChecked = event.target.checked;

    setSelectedAnswers((prev) => {
      const currentAnswers = prev[currentQuestionIndex] || [];
      if (isChecked) {
        // Add the selected option to the list
        return {
          ...prev,
          [currentQuestionIndex]: [...currentAnswers, optionValue],
        };
      } else {
        // Remove the unselected option from the list
        return {
          ...prev,
          [currentQuestionIndex]: currentAnswers.filter(
            (val) => val !== optionValue
          ),
        };
      }
    });
  };

  // Move to the next question
  const handleNext = () => {
    if (currentQuestionIndex < questions?.length - 1) {
      setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
    }
  };

  // Move to the previous question
  const handlePrev = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex((prevIndex) => prevIndex - 1);
    }
  };

  // Check if all questions have been attempted
  const allQuestionsAnswered = questions.every((_, index) => {
    const selectedAnswer = selectedAnswers[index];
    return Array.isArray(selectedAnswer)
      ? selectedAnswer.length > 0
      : !!selectedAnswer;
  });

  // Submit the quiz
  const handleSubmit = () => {
    const { correct, incorrect } = computeQuizScore(questions, selectedAnswers);

    setCorrectCount(correct);
    setIncorrectCount(incorrect);
    setSubmittedTest(true);
    setSubmitted(true);
    setCurrentQuestionIndex(0);
    if (correct !== questions?.length && incorrect !== 0) {
      let practiceQuizData = {
        courseId: course_id,
        isCompleted: false,
        practiceContentId: contentId,
      }
      let data = {
        sectionId: sectionIdFromRedux,
        dataId: dataId,
        percent: 0,
        courseId: course_id,
        isRead: false,
      };
      handleUpdateCourseProgress(data);
      dispatch(practiceQuizAttemptsData(practiceQuizData));
      return;
    }
    if (correct === questions?.length && incorrect === 0) {
      let data = {
        sectionId: sectionIdFromRedux,
        dataId: dataId,
        percent: 100,
        courseId: course_id,
        isRead: true,
      };
      handleUpdateCourseProgress(data);
      let practiceQuizzData = {
        courseId: course_id,
        isCompleted: true,
        practiceContentId: contentId,
      }
      dispatch(practiceQuizAttemptsData(practiceQuizzData)).then((res) => {
        if(res?.payload?.isCompleted) {
          const currentProgress = Math.round(coursePercentage || learningData?.selfLearningData?.data?.progressPercent || res?.payload?.courseProgressUserSpecific);
          if (currentProgress < 99) {
          setShowCourseModalAfterQuiz(true);
          setSuppressCourseModal(true);
          }
          
          // Only show practice quiz modal if: 
          // 1. Course is not expired, OR
          // 2. Course is expired but neverExpired flag is NOT set to true
          // Don't show if: course is expired AND neverExpired is true
          const shouldShowModal = !isCourseExpired || (isCourseExpired && neverExpired !== true);
          
          if (shouldShowModal) {
            setIsPracticeQuizModal(true);
          }
        }
        setPracticeQuizData(res);
      });
    }
  };

  // Render logic for options
  const currentQuestionOptions = Array.isArray(currentQuestion?.options)
    ? currentQuestion.options
    : [];
  const isMultipleChoice =
    currentQuestionOptions.filter((option) => option?.correct).length > 1;

  const renderOptions = () => {
    return mappedOptions.map((option) => {
      const isSelected =
        selectedAnswers[currentQuestionIndex]?.includes(option?.value) ||
        selectedAnswers[currentQuestionIndex] === option?.value;
      const isAnswerCorrect = isSelected && submitted && option?.isCorrect;
      const isAnswerWrong = isSelected && submitted && !option?.isCorrect;
      let answerClass = "";
      if (isAnswerWrong) {
        answerClass = classes.incorrectOption;
      } else if (isAnswerCorrect) {
        answerClass = classes.correctOption;
      }

      return (
        <Box
          key={option?.value}
          className={`${classes.optionContainer} ${answerClass}`}
        >
          <Box className={classes.iconContainer}>
            {isAnswerCorrect && (
              <CheckCircleIcon className={classes.checkIcon} />
            )}
            {isAnswerWrong && <CancelIcon className={classes.crossIcon} />}
          </Box>
          {isMultipleChoice ? (
            <Box className={classes.checkboxLabelContainer}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isSelected}
                    onChange={(e) =>
                      handleOptionChangeForMultiple(e, option?.value)
                    }
                    disabled={submitted}
                  />
                }
                label={<span>{option?.label}</span>}
              />
            </Box>
          ) : (
            <Box className={classes.radioLabelContainer}>
              <FormControlLabel
                value={option?.value}
                control={
                  <Radio
                    checked={isSelected}
                    onChange={handleOptionChange}
                    disabled={submitted}
                  />
                }
                label={<span>{option?.label}</span>}
              />
            </Box>
          )}
        </Box>
      );
    });
  };

  // retake the quiz
  const handleRetake = () => {
    setCurrentQuestionIndex(0);
    setSelectedAnswers({});
    setCorrectCount(0);
    setIncorrectCount(0);
    setSubmittedTest(false);
    setSubmitted(false);
  };

  const submitTooltipTitle = allQuestionsAnswered ? "" : t("Please attempt all the questions");
  const startButtonClassName = testDisabled
    ? classes.startBtn + " " + classes.buttonDisabled
    : classes.startBtn;

  return (
    <>
      {isMockTest ? (
        <Box
          className={classes.wrapper}
          style={{
            backgroundImage: `url(${rectangleQuizImage})`,
            backgroundSize: "cover",
            padding: "0px",
            border: "none",
            boxShadow: "none",
          }}
        >
          <Box className={classes.topTitleContent}>{mySectionData?.testName}</Box>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Box className={classes.quizBlock}>
                <Box className={classes.dataCount} style={{ color: theme?.secondaryColor }}>
                  {props?.selectedQuizCard?.data?.evaluationTest?.[0]?.quizAttempts ?? 0}/{quizAttemptsCount}
                </Box>
                <Box className={classes.countTitle}>{t("Attempt")}</Box>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box className={classes.quizBlock}>
                <Box className={classes.dataCount} style={{ color: theme?.secondaryColor }}>{quiz?.total}</Box>
                <Box className={classes.countTitle}>{t("question")}</Box>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box className={classes.marksBlock}>
                <Box className={classes.dataCount} style={{ color: theme?.secondaryColor }}>
                  {quiz?.duration}{":00"} {t("MIN")}
                </Box>
                <Box className={classes.countTitle}>{t("Duration")}</Box>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box className={classes.expiryBlock}>
                <Box className={classes.dataCount} style={{ color: theme?.secondaryColor }}>{quiz?.mark}</Box>
                <Box className={classes.countTitle}>{t("total_marks")}</Box>
              </Box>
            </Grid>
          </Grid>
          <Box className={classes.instructionText}>{t("Instructions")}</Box>
          <Box className={classes.upperBlock}>
            <Box>
              <ul className={classes.blockInstruction}>
                <li>{t("YOU_WILL_GET_ONLY")} {quizAttemptsCount} {t("ATTEMPTS")} {t("PLEASE_ENSURE_THAT_YOU_HAVE_RELIABLE_INTERNET")}</li>
                <li>{t("EVALUTE_ALL_OPTIONS_CAREFULLY")}</li>
                <li>{t("THIS_TEST_MIGHT_HAVE")} {t("NEGATIVE_MARKING")} {t("YOU_WILL_SEE_NEGATIVE_POSITIVE_NEGATIVE_MARK")}. </li>
                <li style={{ color: '#d71a20', fontWeight: '400' }}>{t("If you change the tab, return to a previous page or minimize the browser during the test, it will be automatically submitted")}</li>
                <li style={{ color: '#d71a20', fontWeight: '400' }}>{t("Once the certificate is unlocked, you cannot attempt the evaluation test again")}</li>
              </ul>
            </Box>
          </Box>
          <Box className={classes.buttonBlock}>
            <OverlayButton
              onClick={startQuiz}
              disabled={testDisabled}
              title={t("Start_Test")}
              classStyleHeading={startButtonClassName}
            />
            {quizAttemptForResult != null && quizAttemptForResult > 0 && (
              <OverlayButton
                onClick={showResult}
                title={t("view_result")}
                classStyleHeading={classes.startBtn}
              />
            )}
          </Box>
          {isModalVisible && (
            <Modal open={isModalVisible} onClose={closeModal}>
              {quizModal}
            </Modal>
          )}
        </Box>
      ) : (
        <Box className={classes.practiceBox}>
          {submitted && (
            <Box className={classes.headerBox}>
              <Box className={classes.scoreInfo}>
                <Box className={classes.scoreItem}>
                  <Box className={`${classes.scoreBox} ${classes.correctBox}`} />
                  <Typography className={classes.correctInfo}>{t('Correct')} <span className={classes.correctInfoCount}>{correctCount}</span></Typography>
                </Box>
                <Box className={classes.scoreItem}>
                  <Box className={`${classes.scoreBox} ${classes.incorrectBox}`} />
                  <Typography className={classes.correctInfo}>{t('incorrect')} <span className={classes.correctInfoCount}>{incorrectCount}</span></Typography>
                </Box>
              </Box>
              <Button className={classes.retakeButton} onClick={handleRetake}><ReplayIcon />{t('Retake')}</Button>
            </Box>
          )}
          <Box className={classes.practiceDataBox}>
            <Box className={classes.questionNumber}>
              {("QUESTION")} {currentQuestionIndex + 1} {("of")} {questions?.length}
              <Box className={classes.buttonContainer}>
                {currentQuestionIndex > 0 && (
                  <Button className={classes.previousButton} variant="outlined" onClick={handlePrev}>
                    <Typography>{"<"}</Typography> {t('Previous')}
                  </Button>
                )}
                {currentQuestionIndex < questions?.length - 1 ? (
                  <Button className={classes.nextButton} variant="contained" onClick={handleNext}>
                    {t("Next")}<Typography>{">"}</Typography>
                  </Button>
                ) : (
                  <>
                    {submitted ? (
                      <Button className={classes.disabledButton} variant="contained" disabled>
                        {t("Next")}<Typography>{">"}</Typography>
                      </Button>
                    ) : (
                      <Tooltip title={submitTooltipTitle} arrow>
                        <Box>
                          <Button className={classes.nextButton} variant="contained" onClick={handleSubmit} disabled={!allQuestionsAnswered}>
                            {t("Submit")}
                          </Button>
                        </Box>
                      </Tooltip>
                    )}
                  </>
                )}
              </Box>
            </Box>
            {currentQuestion?.directionId?.direction && (
              <Box className={classes.questionText} style={{ fontWeight: '300' }}>
                <span dangerouslySetInnerHTML={{ __html: currentQuestion?.directionId?.direction?.replace(/<img[^>]*>/g, "") }} />
              </Box>
            )}
            {currentQuestion?.directionId?.direction?.match(/<img[^>]*>/g)?.map((imgTag) => (
              <Box key={imgTag} className={classes.questionImage} dangerouslySetInnerHTML={{ __html: imgTag }} />
            ))}
            {currentQuestion?.directionId?.direction && (
              <Box className={classes.questionText} style={{ fontWeight: '500' }}>{t('Based on the passage, answer the following questions')}</Box>
            )}
            <Box className={classes.questionText} style={{ fontWeight: '500' }}>
              <span>Q.</span>
              <span dangerouslySetInnerHTML={{ __html: currentQuestion?.title?.replace(/<img[^>]*>/g, "") }} />
            </Box>
            {currentQuestion?.title?.match(/<img[^>]*>/g)?.map((imgTag) => (
              <Box key={imgTag} className={classes.questionImage} ref={contentRef} dangerouslySetInnerHTML={{ __html: imgTag }} />
            ))}
            <Modal open={open} onClose={() => setOpen(false)}>
              <Box className={classes.modalWrapper}>
                <IconButton className={classes.closeButton} onClick={() => setOpen(false)}><CloseIcon style={{ color: "white" }} /></IconButton>
                <IconButton className={classes.zoomInButton} onClick={handleZoomIn}><ZoomInIcon style={{ color: "white" }} /></IconButton>
                <IconButton className={classes.zoomOutButton} onClick={handleZoomOut}><ZoomOutIcon style={{ color: "white" }} /></IconButton>
                <Box className={classes.zoomModalContent}>
                  <img src={imgSrc} alt="Zoomable" className={classes.modalImage} style={{ transform: `scale(${zoom})` }} />
                </Box>
              </Box>
            </Modal>
            {currentQuestion?.type === "MultiChoice" && (
              <Box className={classes.multipleText}>*{t('You can select more than one option')}</Box>
            )}
            <Box className={classes.options}>{renderOptions()}</Box>
          </Box>
        </Box>
      )}
    </>
  );
}

const styles = (theme) => ({
  practiceBox: {
    display: "block",
    height: "100%",
    "@media (min-width:280px) and (max-width: 767px)": {
      padding: "15px 0",
      height: "100%",
    },
  },
  headerBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#0C34500A",
    borderRadius: "10px 10px 0 0",
    padding: "12px 12px 12px 40px",
    "@media (max-width: 767px)": {
      padding: "12px",
    },
  },
  scoreInfo: {
    display: "flex",
    gap: "15px",
    alignItems: "center",
  },
  multipleText: {
    color: "#F75151",
    fontSize: "12px",
    fontStyle: "italic",
    fontWeight: "300",
    paddingLeft: '40px',
    marginBottom: "10px"
  },
  scoreItem: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  scoreBox: {
    width: "12px",
    height: "12px",
    borderRadius: "2px",
  },
  correctBox: {
    backgroundColor: "#2E7D32",
  },
  incorrectBox: {
    backgroundColor: "#C62828",
  },
  correctInfo: {
    fontSize: "12px",
    fontWeight: 400,
    color: "#000000B2",
  },
  correctInfoCount: {
    fontSize: "12px",
    fontWeight: 600,
    color: "#000000DE",
  },
  retakeButton: {
    color: "#0C3450",
    fontSize: "14px",
    fontWeight: 600,
    padding: "5px 10px",
    borderRadius: "5px",
    textTransform: "capitalize",
    "& .MuiSvgIcon-root": {
      width: "16px",
      height: "20px",
      marginRight: "8px",
    },
  },
  practiceDataBox: {
    backgroundColor: "#fff",
    padding: "40px 40px 40px 0px",
    boxShadow: `1.95px 1.95px 2.6px 0px ${ColorsConstant.boxShadow}`,
    display: "block",
    height: "100%",
    "@media (min-width:280px) and (max-width: 767px)": {
      padding: "15px 16px 0px 16px",
      height: "100%",
    },
  },
  questionNumber: {
    fontSize: "14px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: 500,
    color: "#202020",
    marginBottom: "10px",
    paddingLeft: "40px",
    "@media (max-width: 767px)": {
      paddingLeft: 0,
    },
  },
  questionText: {
    fontSize: "16px",
    color: "#202020",
    paddingLeft: "40px",
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: '10px',
    gap: '6px',
    "@media (max-width: 767px)": {
      paddingLeft: 0,
      fontSize: 16,
    },
    "& span": {
      "& p":{
        margin: "0.4em 0px",
        "& br": {
        display: 'none'
      }
      }
    },
  },
  questionImage: {
  paddingLeft: "40px",
  "@media (max-width: 767px)": {
    paddingLeft: 0,
  },
    "& img": {
      width: "40%",
      height: "auto",
      display: "block",
      margin: "16px 0px",
      cursor: "pointer",
      "@media (max-width: 767px)": {
        width: "100%",
      },
    },
},

  disabledButton: {
    textTransform: "capitalize",
    "& .MuiButton-label": {
      gap: "8px",
    },
  },
  checkboxLabelContainer: {
    "& .MuiCheckbox-colorSecondary": {
      "&.Mui-checked": {
        color: ColorsConstant.defaultBlue,
      },
    },
  },
  optionContainer: {
    display: "flex",
    alignItems: "center",
    padding: "0px 8px",
    borderRadius: "4px",
    justifyContent: "flex-start",
    paddingLeft: "10px",
    "& .MuiFormControlLabel-label ": {
      color: ColorsConstant.descriptionColor,
      fontSize: "16px",
      fontWeight: 400,
    },
    "@media (max-width: 767px)": {
      padding: 0,
    },
  },
  incorrectOption: {
    backgroundColor: "#FEEBEE",
    "& .MuiFormControlLabel-label ": {
      color: "rgba(0, 0, 0, 0.55);",
      fontSize: "16px",
      fontWeight: 400,
    },
  },
  correctOption: {
    backgroundColor: "#F1F8E9",
    "& .MuiFormControlLabel-label ": {
      color: "rgba(0, 0, 0, 0.55);",
      fontSize: "16px",
      fontWeight: 400,
    },
  },
  crossIcon: {
    marginRight: "8px",
    color: "#C62828",
  },
  checkIcon: {
    marginRight: "8px",
    color: "#2E7D32",
  },
  iconContainer: {
    width: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "8px",
    paddingLeft: "12px",
  },
  radioLabelContainer: {
    display: "flex",
    alignItems: "center",
    flex: 1,
    paddingLeft: "16px",
    "& label > span": {
      "&.Mui-checked": {
        "& svg": {
          color: "#0C3450",
        },
      },
      "&:hover": {
        backgroundColor: "rgba(245, 0, 87, 0.03) !important",
      },
    },
    "@media (max-width: 767px)": {
      paddingLeft: 0,
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  nextButton: {
    backgroundColor: "#0C3450",
    color: "#fff",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#144160",
    },
    "& .MuiButton-label": {
      gap: "8px",
    },
  },
  previousButton: {
    borderColor: "#0C3450",
    color: "#000000",
    textTransform: "capitalize",
    "&:hover": {
      borderColor: "#0C3450",
      color: "#0C3450",
    },
    "& .MuiButton-label": {
      gap: "8px",
    },
  },
  wrapper: {
    display: "block",
    height: "calc(100svh - 100px)",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",

    "@media (min-width:280px) and (max-width: 767px)": {
      padding: "15px 16px 0px 16px",
      height: "100%",
    },
  },
  questionDuration: {
    display: "flex",
    "@media (max-width: 767px)": {
      display: "block",
    },
    "@media (max-width: 960px)": {
      borderTop: "1px solid #E3E3E3",
    },
  },
  upperBlock: {
    display: "flex",
    "@media (max-width: 960px)": {
      borderBottom: "none",
    },
  },
  instructionText: {
    color: "#0C3450",
    fontSize: "18px",
    fontWeight: 400,
    paddingTop: "55px",
    paddingBottom: "12px",
    "@media (max-width: 767px)": {
      fontSize: "14px",
      paddingTop: "15px",
    },
  },
  blockInstruction: {
    color: ColorsConstant.descriptionColor,
    fontSize: "14px",
    fontWeight: 400,
    padding: "0px 20px",
    "& li": {
      paddingBottom: "15px",
    },
    "@media (max-width: 767px)": {
      fontSize: "12px",
    },
  },
  bottomBlock: {
    display: "flex",
    justifyContent: "flex-start",
    padding: "18px 0px",
    borderBottom: "1px solid #E3E3E3",
  },
  quizBlock: {
    padding: "0px 20px",
    borderRight: "1px solid #E3E3E3",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  topTitleContent: {
    fontSize: "24px",
    fontWeight: "400",
    paddingBottom: "8px",
    "@media (max-width:767px)": {
      fontSize: "16px",
      paddingTop: '8px'
    },
  },
  subTitleContent: {
    fontSize: "24px",
    fontWeight: "400",
    paddingBottom: "32px",
    "@media (max-width:767px)": {
      fontSize: "14px",
    },
  },
  marksBlock: {
    padding: "0px 20px",
    borderRight: "1px solid #E3E3E3",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    "@media (max-width: 767px)": {
      padding: "0px",
    },
  },
  expiryBlock: {
    padding: "0px 20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "@media (max-width: 767px)": {
      borderRight: "0px",
      padding: "0px",
    },
  },
  timeBlock: {
    padding: "0px 20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "@media (max-width: 767px)": {
      borderTop: "1px solid #E3E3E3",
    },
  },
  dataCount: {
    textAlign: "center",
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "25px",
    paddingBottom: "5px",
    "@media (max-width: 767px)": {
      fontSize: "14px",
    },
  },
  countTitle: {
    color: ColorsConstant.descriptionColor,
    textAlign: "center",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "22px",
    "@media (max-width: 767px)": {
      fontSize: "12px",
    },
  },
  startBtn: {
    "&:hover": {
      background: "#0c3450e0 !important",
    },
    minWidth: "140px",
    height: "40px",
    textTransform: "capitalize",
    fontSize: "16px",
    fontWeight: 600,
    cursor: "pointer",
    "@media (min-width:280px) and (max-width: 767px)": {
      width: 140,
      fontSize: 12,
    },
  },
  buttonBlock: {
    gap: "4px",
    textTransform: "capitalize",
    display: "flex",
    justifyContent: "flex-start",
    "@media (min-width:280px) and (max-width: 767px)": {
      paddingBottom: 30,
    },
    "@media (min-width:768px) and (max-width: 1024px)": {
      paddingTop: 30,
    },
    "@media (min-width:1231px) and (max-width: 1650px)": {
      paddingTop: 10,
    },
  },
  buttonDisabled: {
    opacity: "0.4",
    cursor: "not-allowed",
  },
  modalBg: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "9999",
  },
  modalContent: {
    width: "460px",
    margin: "auto",
    marginTop: "40vh",
    "@media (max-width:439px)": {
      width: "280px",
    },
  },
  heading: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    padding: "20px 40px",
    borderRadius: "6px",
  },
  headingText: {
    fontWeight: "normal",
    color: "black",
  },
  okBtn: {
    fontWeight: "500",
    padding: "10px 30px",
    fontSize: "15px",
    borderRadius: "4px",
    margin: "15px",
    backgroundColor: "#0C3450",
    color: "white",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#0c3450e0 !important",
    },
  },
  okAlign: {
    display: "flex",
    flexDirection: "row",
  },
  modalWrapper: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.95)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        zIndex: 1300,
    },
    zoomModalContent: {
        maxWidth: "90vw",
        maxHeight: "90vh",
        overflow: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    modalImage: {
        transition: "transform 0.2s ease-in-out",
        maxWidth: "100%",
        maxHeight: "100%",
    },
    closeButton: {
        position: "absolute",
        top: 20,
        right: 20,
    },
    zoomInButton: {
        position: "absolute",
        top: 20,
        right: 70,
    },
    zoomOutButton: {
        position: "absolute",
        top: 20,
        right: 120,
    },
});

InstructionBlock.propTypes = {
    startQuiz: PropTypes.func,
    quiz: PropTypes.object,
    quizAttemptForResult: PropTypes.object,
    unlockEvaluationTest: PropTypes.func,
    certificateUnlocked: PropTypes.bool,
    startButtonClicked: PropTypes.bool,
    selectedQuizCard: PropTypes.object,
    courseName: PropTypes.string,
    handleUpdateCourseProgress: PropTypes.func,
    course_id: PropTypes.string,
    contentId: PropTypes.string,
    setSubmittedTest: PropTypes.func,
    setIsPracticeQuizModal: PropTypes.func,
    setPracticeQuizData: PropTypes.func,
    setShowCourseModalAfterQuiz: PropTypes.func,
    coursePercentage: PropTypes.number,
    setSuppressCourseModal: PropTypes.func,
    isCourseExpired: PropTypes.bool,
    neverExpired: PropTypes.bool
};

export default InstructionBlock;
